module.exports = __webpack_public_path__ + "static/img/info-icon-3.3af1bcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-icon-3.png
// module id = rxhp
// module chunks = 5